/* tslint:disable */
/* eslint-disable */
export enum FeePlanOrderBy {
  Id = 'Id',
  Description = 'Description',
  Name = 'Name'
}
